



























import Vue from 'vue';
import _ from 'lodash';
import { Loader } from 'mycorems-app-shared';
import { Price } from '../types';
import repository from './price-repository';
import money from './pricing';

interface Data {
  price: Price|null,
  task: Promise<Price>|null,
}

export default Vue.extend({
  props: {
    customerId: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    currency: String,
  },
  data(): Data {
    return {
      price: null,
      task: null,
    };
  },
  watch: {
    customerId: {
      handler() {
        this.calculate();
      },
      immediate: true,
    },
    amount: {
      handler() {
        this.calculate();
      },
      immediate: true,
    },
  },
  computed: {
    currencyValue(): string {
      if (this.currency) return this.currency.toUpperCase();
      if (this.price) {
        return this.price.currency.toUpperCase();
      }
      return 'USD';
    },
  },
  methods: {
    calculate(): void {
      this.task = repository.calculate(this.customerId, this.currencyValue, this.amount);
      this.task.then((price: Price) => {
        this.price = price;
      });
    },
  },
  filters: {
    money(cents: number) {
      return money(cents);
    },
  },
  created(): void {
    this.calculate();
  },
  components: {
    Loader,
  },
});
